import axios from 'axios';
import { responseInterceptor, errorInterceptor } from './interceptors';
import env from 'config/env';

const defaultOptions = {
  baseURL: env.apiUrl,
  headers: {
    'Content-Type': 'application/json'
  },
};

function urlBase() {
  if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "HML") {
    return "https://eva-hom.pefisa.com.br/api";
  } else if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "local") {
    return "https://localhost:5002/api";
  } else if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "PRD") {
    return "https://eva.pefisa.com.br/api";
  } else {
    return "";
  }
}

const defaultOptionsCrib = {
  // PRD -> https://eva.pefisa.com.br/api
  baseURL: "https://eva.pefisa.com.br/api",
  headers: {
    'Content-Type': 'application/json'
  },
};


const Api = axios.create(defaultOptions);
const ApiCrib = axios.create(defaultOptionsCrib);


Api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);

ApiCrib.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);



export { Api,ApiCrib };
